module.exports = __webpack_public_path__ + "static/media/om_hairstyle_suave_front.621133a1.png";